import _ from "lodash";

// 데스티네이션 태그 여부(리플, 모네로, 티티엠씨)
export const getTagInfo = code => {
  const tagIncludedCoinList = [
    { code: "XRP", required: false },
    { code: "XMR", required: false },
    { code: "TTMC", required: false },
  ];
  return _.find(tagIncludedCoinList, { code });
};

export const hasTag = code => {
  return !!getTagInfo(code);
};

export const tagRequired = code => {
  return _.get(getTagInfo(code), "required");
};
